export function rateLimitDateWhenUserNextAbleToComment() {
  throw new Error('rateLimitDateWhenUserNextAbleToComment called on the client!');
}

export function rateLimitDateWhenUserNextAbleToPost() {
  throw new Error('rateLimitDateWhenUserNextAbleToPost called on the client!');
}

export function getRecentKarmaInfo() {
  throw new Error('getRecentKarmaInfo called on the client!');
}
